import React from 'react';
import { Flex, type FlexProps, Typography } from 'antd';
import {
  type TStatuses,
  type Value,
  type StatusKeys,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import { getReadingInfo, hiddenThresholds } from 'utils/get-reading-info';

import s from './styles.module.scss';

const { Text } = Typography;

interface IReadingsListProps extends Omit<FlexProps, 'children'> {
  id: string;
  values: Value;
  statuses: TStatuses;
  fontWeight?: number;
  timestampText?: string;
}

const ReadingsList: React.FC<IReadingsListProps> = ({
  id,
  values,
  statuses,
  fontWeight = 700,
  timestampText = '',
  ...props
}) => {
  let isFirstElement = true;

  return (
    <Flex vertical justify="center" {...props}>
      {Object.keys(values).map((threshold) => {
        if (hiddenThresholds.includes(threshold)) {
          return null;
        }
        const { className, key, value, unit } = getReadingInfo(
          statuses,
          values,
          threshold as StatusKeys,
        );

        const isFirst = isFirstElement;
        isFirstElement = false;

        return (
          <Text className={s['patient-health-text']} key={`${id}-${threshold}`}>
            <Text className={s[className]} style={{ fontWeight }}>
              <Text className={s['key-text']}>{key}</Text>
              {` ${value} ${unit}`}
            </Text>
            {isFirst && timestampText && (
              <Text className={s['timestamp-text']}>{timestampText}</Text>
            )}
          </Text>
        );
      })}
    </Flex>
  );
};

export default ReadingsList;
